import React from 'react';
import { Box, Flex, Image, Text } from '@chakra-ui/react';

const DashboardDisplayCards = ({name, number, bgcolor, icon, imgBgColor}) => {
  return (
    <Box>
        <Flex padding={'20px 15px'} border={"0.86px solid #E3EBEE"} borderRadius={"8px"} bgColor={bgcolor} height={['122px','122px', '140px', '122px']} justifyContent={'center'} alignItems={'center'} gap={3} width={'100%'}>
            <Flex width={'25%'} justifyContent={'center'} alignItems={'center'} bgColor={imgBgColor} borderRadius={'4px'} height={'40px'}>
                <Image src={icon} alt={"logo Icon"} width={'25px'} height={'28px'} objectFit={'contain'} />
            </Flex>
            <Flex width={'75%'} flexDirection={'column'} gap={1} fontFamily={'inter'}>
                <Text fontSize={'16px'} fontWeight={'700'} color={'#2E2E2E'}>{number}</Text>
                <Text fontSize={'12px'} fontWeight={'600'} color={'#71747D'}>{name}</Text>
            </Flex>

        </Flex>
    </Box>
  )
}

export default DashboardDisplayCards;